import { render, staticRenderFns } from "./TechCategoryCenterTable.vue?vue&type=template&id=c62bc004&scoped=true&"
import script from "./TechCategoryCenterTable.vue?vue&type=script&lang=js&"
export * from "./TechCategoryCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./TechCategoryCenterTable.vue?vue&type=style&index=0&id=c62bc004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62bc004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
